export const USERS_EDIT_EMPLOYER_UPDATE_REQUEST = 'users/edit-employer-update-request'
export const USERS_EDIT_EMPLOYER_UPDATE_SUCCESS = 'users/edit-employer-update-success'
export const USERS_EDIT_EMPLOYER_UPDATE_FAILED = 'users/edit-employer-update-failed'
